import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Auth0User } from "../../types";

// Define the type for your Auth0 user information.
// Adjust this interface to match the actual structure of your Auth0 user object.

const initialState: Auth0User = {
  sub: "", // User ID
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(_, action: PayloadAction<Auth0User>) {
      return { ...action.payload };
    },
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
